import { authProfileAdapter } from '../profileAdapter'

const profileState = {
  adapter: authProfileAdapter,
}

export function setAuthProfileAdapter(adapter) {
  profileState.adapter = adapter || authProfileAdapter
}

export function useAuthProfileAdapter() {
  return profileState.adapter
}
